(function () {
  'use strict';

  angular.module('ringbaPortal').component('offerForm', {
    bindings: {
      campaignId: '<',
      campaignCountry: '<',
      publishedOffer: '<',
      currentOffer: '<',
      isDraft: '<',
      isReadonly: '<',
      focusForm: '<',
      onCampaignOfferChange: '&',
      cancelForm: '&'
    },
    controller: OfferFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/offer-form/offer-form.view.html'
  });

  function OfferFormController(
    $filter,
    $scope,
    $timeout,
    $uibModal,
    accountsService,
    bsLoadingOverlayService,
    callLogsService,
    dateTimeService,
    infoService,
    moment,
    offersService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    const languagesLoaderRefId = 'loadingLanguages';

    vm.offerObj = {
      numberRestrictions: {
        allowTF: true,
        allowDID: true,
        maxNumbersPerPublisher: 1
      },
      offerVisibility: 'private',
      languageCodes: ['EN']
    };
    vm.isTollFreeEnabled = true;
    vm.disableApproval = true;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.saveAsDraft = saveAsDraft;
    vm.saveAndPublishConfirm = saveAndPublishConfirm;
    vm.publishOffer = publishOffer;
    vm.handleExpirationChange = handleExpirationChange;
    vm.handleTimeZoneChange = handleTimeZoneChange;
    vm.showExpiryField = showExpiryField;
    vm.hideExpiryField = hideExpiryField;
    vm.handleVisibilityChange = handleVisibilityChange;
    vm.refreshResults = refreshResults;
    vm.onNumberRestrictionChange = onNumberRestrictionChange;
    vm.cancelModal = cancelModal;

    function onInit() {
      _loadLanguages();
      _loadTimeZones();
      _loadOfferCategories();
      _loadCampaignCountry();
      vm.offerVisibilityValues = infoService.getOfferVisibilityValues();
      if (!vm.currentOffer) {
        handleVisibilityChange(vm.offerObj.offerVisibility);
      }
    }

    function onChanges(changesObj) {
      if (changesObj.currentOffer && vm.currentOffer) {
        vm.offerObj = angular.copy(vm.currentOffer);
        vm.displayExpiryField = !!(vm.offerObj && vm.offerObj.expiration);
        vm.minExpirationDate = vm.displayExpiryField ? vm.offerObj.expiration : null;
        _addCurrentCategoryIfNotFound(vm.offerObj.category, vm.offerCategories);
        vm.disableApproval = vm.currentOffer.offerVisibility !== 'account';
        _setCurrentOfferExpirationValidity(vm.currentOffer);
      }
    }

    function showExpiryField() {
      vm.displayExpiryField = true;
      vm.offerObj.expiration = moment().format('D MMM YYYY, hh:mm A');
      vm.minExpirationDate = null;
      vm.offerObj.timeZoneId = dateTimeService.getTimeZoneForBackend(moment.tz.guess());
    }

    function hideExpiryField() {
      vm.displayExpiryField = false;
      vm.offerObj.expiration = null;
      vm.offerObj.timeZoneId = null;
    }

    function handleExpirationChange(expiration) {
      vm.minExpirationDate = expiration;
      _setExpirationValidity(expiration);
    }

    function handleTimeZoneChange() {
      _setExpirationValidity(vm.offerObj.expiration);
    }

    function saveAsDraft() {
      return offersService.saveDraftOffer(accountsService.currentAccountId, vm.campaignId, vm.offerObj).then(function() {
        toaster.pop('success', $filter('translate')('OFFER_DRAFT_SAVE_SUCCESS'));
        vm.onCampaignOfferChange();
      }).catch(utils.errorHandler);
    }

    function saveAndPublishConfirm() {
      vm.publishConfirmationMessage = $filter('translate')('OFFER_NEW_PUBLISH_CONFIRMATION');
      if (vm.publishedOffer) {
        vm.publishConfirmationMessage = $filter('translate')('OFFER_NEW_REVISION_PUBLISH_CONFIRMATION');
      }
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/offer/publish-offer-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function publishOffer() {
      return offersService.saveDraftOffer(accountsService.currentAccountId, vm.campaignId, vm.offerObj).then(function() {
        return offersService.publishDraftOffer(accountsService.currentAccountId, vm.campaignId);
      }).then(function() {
        toaster.pop('success', $filter('translate')('OFFER_PUBLISH_SUCCESS'));
        offersService.initNextSteps(vm.campaignId);
        cancelModal();
        vm.onCampaignOfferChange();
      }).catch(utils.errorHandler);
    }

    function handleVisibilityChange(visibility) {
      if (visibility === 'private') {
        vm.disableApproval = true;
        vm.offerObj.requireApproval = false;
      } else {
        vm.disableApproval = false;
        vm.offerObj.requireApproval = true;
      }
    }

    function refreshResults($select) {
      if (!$select.search) {
        return angular.copy($select.items);
      }
      const search = $select.search,
        searchLowerCase = search.toLowerCase();
      let list = angular.copy($select.items);
      const FLAG = -1;

      //remove last user input
      list = _.filter(list, function(item) {
        return item.id !== FLAG;
      });

      if (_.find(list, function (item) {
        return item.originalCategory.toLowerCase().indexOf(searchLowerCase) > -1;
      })) {
        $select.setItemsFn(list);
        return;
      }

      //manually add user input and set selection
      const category = _getNewCategory(search, FLAG);

      // $select.items = [category].concat(list);
      $select.setItemsFn([category].concat(list));
      $select.selected = category;
    }

    function onNumberRestrictionChange() {
      if (!vm.offerObj.numberRestrictions.allowDID && !vm.offerObj.numberRestrictions.allowTF) {
        vm.offerForm.allowDID.$setValidity('disableBothNumberTypes', false);
      } else {
        vm.offerForm.allowDID.$setValidity('disableBothNumberTypes', true);
      }
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function _getNewCategory(name, id) {
      return {
        id: id,
        name: name,
        groupCategory: 'Other',
        originalCategory: name
      };
    }

    function _addCurrentCategoryIfNotFound(name, categories) {
      if (!categories) {
        return;
      }

      const found = _.find(categories, function (category) {
        return category.originalCategory.indexOf(name) > -1;
      });

      if (!found) {
        vm.offerCategories.push(_getNewCategory(name, name));
      }
    }

    function _loadOfferCategories() {
      infoService.getOfferCategories(accountsService.currentAccountId).then(function (response) {
        vm.offerCategories = _groupOfferCategories(response.data);
        _addCurrentCategoryIfNotFound(vm.offerObj.category, vm.offerCategories);
      });
    }

    function _groupOfferCategories(categories) {
      return _.map(categories, function(category) {
        return {
          id: category.id,
          groupCategory: category.name.split('\\')[0],
          name: category.name.split('\\')[1],
          originalCategory: category.name
        };
      });
    }

    function _loadLanguages() {
      _showFetchLanguagesLoader();
      infoService.getOfferSupportedLanguages().then(function (response) {
        vm.supportedLanguagesOptions = response.data;
        _hideFetchLanguagesLoader();
      });
    }

    function _showFetchLanguagesLoader() {
      vm.loadingLanguages = true;
      bsLoadingOverlayService.start({
        referenceId: languagesLoaderRefId
      });
    }

    function _hideFetchLanguagesLoader() {
      vm.loadingLanguages = false;
      bsLoadingOverlayService.stop({
        referenceId: languagesLoaderRefId
      });
    }

    function _loadTimeZones() {
      infoService.getTimeZones()
        .then(function (response) {
          vm.timeZones = response.data;
        });
    }

    function _setExpirationValidity(expiration) {
      if (vm.offerObj.timeZoneId) {
        const timeZoneId = dateTimeService.getTimeZoneMapping(vm.offerObj.timeZoneId);
        vm.offerForm.expirationDate.$setValidity('isInPast', !_checkTimeIsBeforeCurrentTime(moment(expiration).tz(timeZoneId), vm.offerObj.timeZoneId));
      }
    }

    function _setCurrentOfferExpirationValidity(offer) {
      if (offer.expiration) {
        $timeout(function () {
          vm.offerForm.expirationDate.$setValidity('isInPast', !_checkTimeIsBeforeCurrentTime(moment(offer.expiration), offer.timeZoneId));
          vm.offerForm.expirationDate.$setDirty();
        }, 0);
      }
    }

    function _checkTimeIsBeforeCurrentTime(momentExpirationTime, timeZoneId) {
      return momentExpirationTime.isBefore(dateTimeService.getCurrentMomentInTimeZone(timeZoneId).add(1, 'minutes'));
    }

    function _loadCampaignCountry() {
      infoService.getCountriesWithAddressCheck()
        .then(function (response) {
          vm.campaignCountryWithAddressCheck = _.find(response.data, function (o) {
            return o.countryCode === vm.campaignCountry;
          });

          // This checks for address requirement of toll free numbers
          vm.isTollFreeEnabled = vm.campaignCountryWithAddressCheck && vm.campaignCountryWithAddressCheck.hasTollFreeNumbers && vm.campaignCountryWithAddressCheck.addressRequirementFullfilledForTollFreeNumbers;

          vm.offerObj.numberRestrictions.allowTF = vm.isTollFreeEnabled;
        })
        .catch(utils.errorHandler);
    }
  }
})();
